import React, { Component } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './styles/map.css';
import L from 'leaflet';

var greenIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });

  var redIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });
  
//const port=process.env.REACT_APP_PORT2
const baseUrl= process.env.REACT_APP_HOST


class TreesObserveredMap extends Component  {

    state = {
        observedTrees: [],
        treesNotObserved: [],
        isLoaded: false
    }

    async componentDidMount(){
        try{
            const response = await fetch (baseUrl+'getObservedTrees');
            const observedTrees = await response.json();
            this.setState({observedTrees: observedTrees, isLoaded: true});
        }catch(err){
            this.setState({isLoaded: false})
            console.log(err);
        }

        try{
            const res = await fetch (baseUrl+'getTreesNotObserved');
            const treesNotObserved = await res.json();
            this.setState({treesNotObserved: treesNotObserved, isLoaded: true});
        }catch(err){
            this.setState({isLoaded: false})
            console.log(err);
        }
    }
render(){
    const {observedTrees, treesNotObserved, isLoaded} = this.state;
    return (
        <div className="map__container">
            <h1 class="display-3 text-center">Observed Tree Map</h1>
            <p class="paragraph-center">Trees observed in the previous seven days are marked in green, all others are in red.</p>
                <p class="paragraph-center">Click on the tree marker for detailed tree information.</p>
            {!isLoaded ? <div>Loading...</div> :
                <MapContainer
                className="map"
                center={[41.815100, -88.051662]}
                zoom={16}
                >
                    <TileLayer
                        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                {observedTrees.map(function(item){
                        return <Marker position={[item.BgLatitude, item.BgLongitude]} icon= {greenIcon}>
                            <Popup>
                                <ul class="treeMapList">
                                    <li>
                                        <h6>Tree Information:</h6>
                                    </li>
                                    <li>
                                        <b>Plant ID:</b> {item.PlantID}
                                    </li>
                                    <li>
                                        <b>Taxon:</b> {item.Taxon}
                                    </li>
                                    <li>
                                        <b>Vernacular:</b> {item.Vernacular}
                                    </li>
                                    <li>
                                        <b>Garden Grid:</b> {item.GardenGrid}
                                    </li>
                                    <li>
                                        <b>Garden Sub Grid:</b> {item.GardenSubGrid}
                                    </li>
                                    <li>
                                        <b>Last Observed:</b> {item.DateObserved}
                                    </li>
                                    <li>
                                        <b>Last Observed By: {item.ObserverID}</b>
                                    </li>
                                </ul>
                            </Popup>
                            </Marker>
                    })
                }
                {treesNotObserved.map(function(item){
                        return <Marker position={[item.BgLatitude, item.BgLongitude]} icon= {redIcon}>
                            <Popup>
                                <ul class="treeMapList">
                                    <li>
                                        <h6>Tree Information:</h6>
                                    </li>
                                    <li>
                                        <b>Plant ID:</b> {item.PlantID}
                                    </li>
                                    <li>
                                        <b>Taxon:</b> {item.Taxon}
                                    </li>
                                    <li>
                                        <b>Vernacular:</b> {item.Vernacular}
                                    </li>
                                    <li>
                                        <b>Garden Grid:</b> {item.GardenGrid}
                                    </li>
                                    <li>
                                        <b>Garden Sub Grid:</b> {item.GardenSubGrid}
                                    </li>
                                    <li>
                                        <b>Last Observed:</b> {item.DateObserved}
                                    </li>
                                    <li>
                                        <b>Last Observed By: {item.ObserverID}</b>
                                    </li>
                                </ul>
                            </Popup>
                            </Marker>
                    })
                }
                </MapContainer>
            }
        </div>
    )
}
};

export default TreesObserveredMap;